import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Modulos } from 'src/app/core/modulos';
import { AcessoModuloResolver } from 'src/app/guards/acesso-modulo.resolve';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { CadastrarPlanejamentoOficinaComponent } from './cadastrar-planejamento-oficina/cadastrar-planejamento-oficina.component';
import { PlanejamentoOficinaComponent } from './planejamento-oficina.component';


const routes: Routes = [
  { path: 'oficinaturmas/cadastrar', component: CadastrarPlanejamentoOficinaComponent,canActivate: [AuthGuard],resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.OFICINA_TURMAS} },
  { path: 'oficinaturmas', component: PlanejamentoOficinaComponent ,canActivate: [AuthGuard],resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.OFICINA_TURMAS} },
  { path: 'menu-sap/oficinaturmas/cadastrar', component: CadastrarPlanejamentoOficinaComponent, canActivate: [AuthGuard], resolve: { perfilAcesso: AcessoModuloResolver }, data: { modulo: Modulos.OFICINA_TURMAS } },
  { path: 'menu-sap/oficinaturmas', component: PlanejamentoOficinaComponent, canActivate: [AuthGuard], resolve: { perfilAcesso: AcessoModuloResolver }, data: { modulo: Modulos.OFICINA_TURMAS } },
  { path: 'menu-pedagogico/oficinaturmas/cadastrar', component: CadastrarPlanejamentoOficinaComponent, canActivate: [AuthGuard], resolve: { perfilAcesso: AcessoModuloResolver }, data: { modulo: Modulos.OFICINA_TURMAS } },
  { path: 'menu-pedagogico/oficinaturmas', component: PlanejamentoOficinaComponent, canActivate: [AuthGuard], resolve: { perfilAcesso: AcessoModuloResolver }, data: { modulo: Modulos.OFICINA_TURMAS } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PlanejamentoOficinaRoutingModule { }
